import { render, staticRenderFns } from "./smsRecord.vue?vue&type=template&id=f2e20ee0"
import script from "./smsRecord.vue?vue&type=script&lang=js"
export * from "./smsRecord.vue?vue&type=script&lang=js"
import style0 from "./smsRecord.vue?vue&type=style&index=0&id=f2e20ee0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports